import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isButtonsTextShown } from '../../../../../selectors/app-settings';
import { purchaseButtonText } from '../../ui-selectors/buttons';
import { getChannelForWidget } from '@wix/wix-vod-shared/common';
import { CurrencySign } from '@wix/wix-vod-shared/components';
import { withTranslation } from '@wix/yoshi-flow-editor';
import styles from './purchase-button.scss';
import classNames from 'classnames';
import { getCurrency } from '../../../../../selectors/currency';

const mapStateToProps = (state, props) => ({
  text: purchaseButtonText(state, props),
  isTextShown: isButtonsTextShown(state),
  channel: getChannelForWidget(state),
});

export default connect(mapStateToProps)(
  withTranslation()(
    class PurchaseButton extends React.Component {
      static propTypes = {
        channel: PropTypes.object.isRequired,
        videoItem: PropTypes.object.isRequired,
        text: PropTypes.object,

        iconClassName: PropTypes.string,

        onClick: PropTypes.func.isRequired,
        isTextShown: PropTypes.bool,

        className: PropTypes.string,
        tabIndex: PropTypes.number,
      };

      render() {
        const {
          text,
          onClick,
          iconClassName,
          className,
          isTextShown,
          videoItem,
          channel,
          tabIndex = 0,
          t,
        } = this.props;
        const currency = getCurrency(videoItem, channel);

        return text ? (
          <button
            data-hook="paid-access-button"
            className={className}
            onClick={onClick}
            tabIndex={tabIndex}
            aria-label={t(
              'widget.mobile.cover-actions-overlay.purchase-button-aria-label',
            )}
            style={{ color: 'inherit' }}
          >
            <div className={classNames(styles.purchaseIcon, iconClassName)}>
              <CurrencySign currency={currency} />
            </div>
            {isTextShown && text}
          </button>
        ) : null;
      }
    },
  ),
);
